var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "section top",
          staticStyle: {
            "flex-direction": "row",
            "line-height": "28px",
            "min-width": "1600px"
          }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "booking" },
              model: {
                value: _vm.job.booking,
                callback: function($$v) {
                  _vm.$set(_vm.job, "booking", $$v)
                },
                expression: "job.booking"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "customs" },
              on: {
                change: function(val) {
                  _vm.job.customsBroker = val ? _vm.job.customsBroker : 0
                  _vm.job.customsDeclarationType = val
                    ? _vm.job.customsDeclarationType
                    : -1
                }
              },
              model: {
                value: _vm.job.customs,
                callback: function($$v) {
                  _vm.$set(_vm.job, "customs", $$v)
                },
                expression: "job.customs"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "comercialInspectation" },
              model: {
                value: _vm.job.comercialInspectation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "comercialInspectation", $$v)
                },
                expression: "job.comercialInspectation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "heating" },
              model: {
                value: _vm.job.heating,
                callback: function($$v) {
                  _vm.$set(_vm.job, "heating", $$v)
                },
                expression: "job.heating"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "itmService" },
              model: {
                value: _vm.job.itmService,
                callback: function($$v) {
                  _vm.$set(_vm.job, "itmService", $$v)
                },
                expression: "job.itmService"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "headwayTail" },
              model: {
                value: _vm.job.headwayTail,
                callback: function($$v) {
                  _vm.$set(_vm.job, "headwayTail", $$v)
                },
                expression: "job.headwayTail"
              }
            },
            [_vm._v(_vm._s(_vm.$t("RailwayExport.isHeadwayTail")))]
          ),
          !_vm.previewConfig
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_insurance_toInsure"],
                      expression: "['button_insurance_toInsure']"
                    }
                  ],
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    disabled: _vm.isEdit,
                    no: "toInsure",
                    type: "primary"
                  },
                  on: { click: _vm.toInsure }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
              )
            : _vm._e(),
          _c("span", { staticStyle: { "margin-left": "20px" } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
          ]),
          _c(
            "el-radio-group",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { disabled: _vm.readonly, no: "lob" },
              on: { change: _vm.lobChangeHandler },
              model: {
                value: _vm.job.lob,
                callback: function($$v) {
                  _vm.$set(_vm.job, "lob", $$v)
                },
                expression: "job.lob"
              }
            },
            [
              _c(
                "el-radio",
                {
                  staticStyle: { "margin-top": "6px" },
                  attrs: { no: "RE", label: "RE" }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))]
              ),
              _c(
                "el-radio",
                {
                  staticStyle: { "margin-top": "6px" },
                  attrs: { no: "RI", label: "RI" }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "tab-railway-booking-UICustom-layout",
        { attrs: { "element-blocks": _vm.elementBlocks } },
        [
          _vm.elementDict.cargoCode.visible
            ? _c(
                "template",
                { slot: "cargoCode" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoCode",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CargoInformation,
                          disabled: _vm.readonly,
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoCode,
                          "allow-create": false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.cargoCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          no: "cargoName",
                          disabled: !(
                            _vm.isEdit &&
                            _vm.job.cargoCode != "" &&
                            _vm.job.cargoCode != null
                          )
                        },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.departureStation.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "departureStation" },
                  slot: "departureStation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.departureStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.departureStation.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", width: "100%" } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "departureStation",
                          disabled: _vm.readonly,
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.job.departureStation,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { parentCallBack: _vm.departureStationChange }
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { width: "80px", "padding-left": "5px" },
                          attrs: { disabled: _vm.readonly, no: "transfer" },
                          model: {
                            value: _vm.job.transfer,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "transfer", $$v)
                            },
                            expression: "job.transfer"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transferStation.visible && _vm.job.transfer
            ? _c(
                "el-form-item",
                { attrs: { slot: "transferStation" }, slot: "transferStation" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transferStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transferStation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transferStation",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_RailwayStation,
                      filterable: "",
                      "default-value": _vm.job.transferStation
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.transferStation = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.diffPlacesCollaborate.visible
            ? _c(
                "template",
                { slot: "diffPlacesCollaborate" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "blue",
                          attrs: {
                            slot: "label",
                            disabled: _vm.readonly,
                            no: "diffPlacesCollaborate"
                          },
                          slot: "label",
                          model: {
                            value: _vm.job.diffPlacesCollaborate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "diffPlacesCollaborate", $$v)
                            },
                            expression: "job.diffPlacesCollaborate"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("RailwayExport.isDiffPlacesCollaborate")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.loadingPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "loadingPlaceCompany",
                          disabled: _vm.readonly,
                          "method-params": {
                            companyLob: "railwayExport",
                            loadingPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.loadingPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.loadingPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.signBillPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "signBillPlaceCompany",
                          disabled: _vm.readonly,
                          "method-params": {
                            companyLob: "railwayExport",
                            signBillPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.signBillPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.signBillPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.fullShipment.visible
            ? _c(
                "template",
                { slot: "fullShipment" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "blue",
                          attrs: {
                            slot: "label",
                            disabled: _vm.readonly,
                            no: "fullShipment"
                          },
                          slot: "label",
                          model: {
                            value: _vm.job.fullShipment,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "fullShipment", $$v)
                            },
                            expression: "job.fullShipment"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.isFullShipment")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.dischargePortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "dischargePortCompany",
                          disabled: _vm.readonly,
                          "method-params": {
                            companyLob: "railwayExport",
                            dischargePortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.dischargePortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dischargePortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationPortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "destinationPortCompany",
                          disabled: _vm.readonly,
                          "method-params": {
                            companyLob: "railwayExport",
                            destinationPortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.destinationPortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.destinationPortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.poNo.visible
            ? _c(
                "el-form-item",
                {
                  class: _vm.poNoRed ? "poNoClass" : "",
                  attrs: { slot: "poNo" },
                  slot: "poNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.poNo.label },
                    slot: "label"
                  }),
                  !_vm.openProjectConfig
                    ? _c("el-input", {
                        attrs: { disabled: _vm.readonly, no: "poNo" },
                        model: {
                          value: _vm.job.poNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "poNo", $$v)
                          },
                          expression: "job.poNo"
                        }
                      })
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c("cargo-project-select", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "22",
                          "default-value": _vm.job.poNo,
                          "customer-id": _vm.job.customerId,
                          "is-linked": _vm.isProjectLinkedCustomer
                        },
                        on: { change: _vm.changeProject }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerDepartment &&
          _vm.elementDict.plannerDepartment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "plannerDepartment" },
                  slot: "plannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "plannerDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.plannerOffice),
                      enables: true,
                      "department-id": Number(_vm.job.plannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.plannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerOffice && _vm.elementDict.plannerOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "plannerOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.plannerOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.plannerOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectName.visible && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectName" }, slot: "projectName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectName.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectName.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "projectName", disabled: true },
                    model: {
                      value: _vm.job.projectName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "projectName", $$v)
                      },
                      expression: "job.projectName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectBatch.visible && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectBatch.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectBatch.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "projectBatch" },
                    model: {
                      value: _vm.job.projectBatch,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "projectBatch", $$v)
                      },
                      expression: "job.projectBatch"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactTelephone.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "contactTelephone" },
                  slot: "contactTelephone"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactTelephone.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactTelephone.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "contactTelephone",
                      disabled: !_vm.electricBusinessBtnEnable || _vm.readonly,
                      maxlength: "32"
                    },
                    model: {
                      value: _vm.job.contactTelephone,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "contactTelephone", $$v)
                      },
                      expression: "job.contactTelephone"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactFax.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "contactFax" }, slot: "contactFax" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactFax.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactFax.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "contactFax",
                      disabled: !_vm.electricBusinessBtnEnable || _vm.readonly,
                      maxlength: "32"
                    },
                    model: {
                      value: _vm.job.contactFax,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "contactFax", $$v)
                      },
                      expression: "job.contactFax"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.doorName.visible && _vm.job.landTransportation
            ? _c(
                "el-form-item",
                { attrs: { slot: "doorName" }, slot: "doorName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.doorName.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.doorName.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "doorName",
                        "value-key": "name",
                        clearable: "",
                        filterable: "",
                        "allow-create": true
                      },
                      on: { change: _vm.doorsChangeHandler },
                      model: {
                        value: _vm.truckingInfo.doorName,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "doorName", $$v)
                        },
                        expression: "truckingInfo.doorName"
                      }
                    },
                    _vm._l(_vm.doorList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactPerson.visible && _vm.job.landTransportation
            ? _c(
                "el-form-item",
                { attrs: { slot: "contactPerson" }, slot: "contactPerson" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactPerson.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactPerson.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "doorMan",
                          placeholder: _vm.$t("Payment.contactPerson")
                        },
                        model: {
                          value: _vm.truckingInfo.doorMan,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                          },
                          expression: "truckingInfo.doorMan"
                        }
                      }),
                      _c(
                        "div",
                        {
                          class: _vm.elementDict.contactPerson.isRequire
                            ? "blue"
                            : "",
                          staticStyle: {
                            width: "65px",
                            padding: "0 10px",
                            "font-size": "12px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                      ),
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "doorManTel",
                          placeholder: _vm.$t("SeaExport.Tel")
                        },
                        model: {
                          value: _vm.truckingInfo.doorManTel,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                          },
                          expression: "truckingInfo.doorManTel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.doorAddr.visible && _vm.job.landTransportation
            ? _c(
                "el-form-item",
                { attrs: { slot: "doorAddr" }, slot: "doorAddr" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.doorAddr.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.doorAddr.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "doorAddr",
                      type: "textarea",
                      rows: 3
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.doorAddr.label,
                          _vm.truckingInfo.doorAddr,
                          function(val) {
                            _vm.truckingInfo.doorAddr = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.truckingInfo.doorAddr,
                      callback: function($$v) {
                        _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                      },
                      expression: "truckingInfo.doorAddr"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isAddUserDefinedRoles
            ? [
                _vm.elementDict.userDefinedRoleId1.visible
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "userDefinedRoleId1" },
                        slot: "userDefinedRoleId1"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.userDefinedRoleId1.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.userDefinedRoleId1.label
                          },
                          slot: "label"
                        }),
                        _c("cargo-user-select", {
                          attrs: {
                            no: "userDefinedRoleId1",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole1"
                            },
                            "default-value": _vm.job.userDefinedRoleId1 || "",
                            placeholder: " ",
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole1
                          },
                          on: { change: _vm.userDefinedRoleId1Handler }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.userDefinedRoleId2.visible
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "userDefinedRoleId2" },
                        slot: "userDefinedRoleId2"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.userDefinedRoleId2.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.userDefinedRoleId2.label
                          },
                          slot: "label"
                        }),
                        _c("cargo-user-select", {
                          attrs: {
                            no: "userDefinedRoleId2",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole2"
                            },
                            "default-value": _vm.job.userDefinedRoleId2 || "",
                            placeholder: " ",
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole2
                          },
                          on: { change: _vm.userDefinedRoleId2Handler }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId3 &&
          _vm.elementDict.userDefinedRoleId3.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId3" },
                  slot: "userDefinedRoleId3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId3.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId3",
                    attrs: {
                      no: "userDefinedRoleId3",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole3"
                      },
                      "default-value": _vm.job.userDefinedRoleId3 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole3
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId3Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId4 &&
          _vm.elementDict.userDefinedRoleId4.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId4" },
                  slot: "userDefinedRoleId4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId4.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId4",
                    attrs: {
                      no: "userDefinedRoleId4",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole4"
                      },
                      "default-value": _vm.job.userDefinedRoleId4 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole4
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId4Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId5 &&
          _vm.elementDict.userDefinedRoleId5.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId5" },
                  slot: "userDefinedRoleId5"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId5.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId5.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId5",
                    attrs: {
                      no: "userDefinedRoleId5",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole5"
                      },
                      "default-value": _vm.job.userDefinedRoleId5 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId5Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId6 &&
          _vm.elementDict.userDefinedRoleId6.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId6" },
                  slot: "userDefinedRoleId6"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId6.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId6.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId6",
                    attrs: {
                      no: "userDefinedRoleId6",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole6"
                      },
                      "default-value": _vm.job.userDefinedRoleId6 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId6Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId7 &&
          _vm.elementDict.userDefinedRoleId7.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId7" },
                  slot: "userDefinedRoleId7"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId7.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId7.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId7",
                    attrs: {
                      no: "userDefinedRoleId7",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole7"
                      },
                      "default-value": _vm.job.userDefinedRoleId7 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId7Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId8 &&
          _vm.elementDict.userDefinedRoleId8.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId8" },
                  slot: "userDefinedRoleId8"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId8.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId8.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId8",
                    attrs: {
                      no: "userDefinedRoleId8",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole8"
                      },
                      "default-multiple-value": _vm.toNumArray(
                        _vm.job.userDefinedRoleId8
                      ),
                      multiple: true,
                      "merge-load": true,
                      placeholder: _vm.readonly ? " " : ""
                    },
                    on: {
                      change: function(p) {
                        _vm.job.userDefinedRoleId8 = _vm.toTxt(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField1.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField1" },
                  slot: "userDefinedField1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField1.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "userDefinedField1",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField1.label,
                          _vm.job.userDefinedField1,
                          function(val) {
                            _vm.job.userDefinedField1 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField1,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField1", $$v)
                      },
                      expression: "job.userDefinedField1"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField2.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField2" },
                  slot: "userDefinedField2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "userDefinedField2",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField2.label,
                          _vm.job.userDefinedField2,
                          function(val) {
                            _vm.job.userDefinedField2 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField2,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField2", $$v)
                      },
                      expression: "job.userDefinedField2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField3.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField3" },
                  slot: "userDefinedField3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField3.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "userDefinedField3",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField3.label,
                          _vm.job.userDefinedField3,
                          function(val) {
                            _vm.job.userDefinedField3 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField3,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField3", $$v)
                      },
                      expression: "job.userDefinedField3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField4.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField4" },
                  slot: "userDefinedField4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField4.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "userDefinedField4",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField4.label,
                          _vm.job.userDefinedField4,
                          function(val) {
                            _vm.job.userDefinedField4 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField4,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField4", $$v)
                      },
                      expression: "job.userDefinedField4"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.taxNature && _vm.elementDict.taxNature.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "taxNature" }, slot: "taxNature" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.taxNature.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.taxNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "taxNature",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.job.taxNature,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "taxNature", $$v)
                        },
                        expression: "job.taxNature"
                      }
                    },
                    _vm._l(_vm.TAX_NATURES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.shipper.visible,
                  expression: "elementDict.shipper.visible"
                }
              ],
              staticStyle: { "margin-right": "10px" },
              attrs: {
                slot: "shipper",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "shipper"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.shipper.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.shipper.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "shipperId",
                      disabled: _vm.readonly,
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.job.shipperId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateShipperList
                        : null
                    },
                    on: { change: _vm.shipperChange }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "29",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "shipperLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "shipperLine" + i,
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "shipperLine" + i,
                            i + 1 > 7 ? null : "shipperLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Shipper"),
                            _vm.mergeShipperLine(),
                            _vm.splitShipperLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["shipperLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "shipperLine" + i, $$v)
                        },
                        expression: "job['shipperLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.consignee.visible,
                  expression: "elementDict.consignee.visible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "consignee",
                "label-width": "65px",
                "label-position": "left"
              },
              slot: "consignee"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.consignee.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.consignee.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "consigneeId",
                      disabled: _vm.readonly,
                      "method-params": { consignee: true, active: true },
                      "default-value": _vm.job.consigneeId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateConsigneeList
                        : null
                    },
                    on: { change: _vm.consigneeChange }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "53",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "consigneeLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "consigneeLine" + i,
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "consigneeLine" + i,
                            i + 1 > 7 ? null : "consigneeLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Consignee"),
                            _vm.mergeConsigneeLine(),
                            _vm.splitConsigneeLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["consigneeLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                        },
                        expression: "job['consigneeLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.notify.visible,
                  expression: "elementDict.notify.visible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "notify",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "notify"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.notify.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.notify.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "notifyId",
                      disabled: _vm.readonly,
                      "method-params": { notify: true, active: true },
                      "default-value": _vm.job.notifyId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateNotifyList
                        : null
                    },
                    on: { change: _vm.notifyChange }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "billAddressDialogVisible",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "notifyLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "notifyLine" + i,
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "notifyLine" + i,
                            i + 1 > 7 ? null : "notifyLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.NotifyParty"),
                            _vm.mergeNotifyLine(),
                            _vm.splitNotifyLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["notifyLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "notifyLine" + i, $$v)
                        },
                        expression: "job['notifyLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm.elementDict.alsoNotify.visible
            ? _c(
                "div",
                { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.alsoNotify.isRequire ? "blue" : "",
                    staticStyle: {
                      display: "inline-block",
                      "line-height": "28px",
                      "padding-bottom": "5px"
                    },
                    attrs: { label: _vm.elementDict.alsoNotify.label }
                  }),
                  _c("br"),
                  _c("cargo-textarea", {
                    staticClass: "also-notify",
                    attrs: {
                      no: "alsoNotify",
                      type: "textarea",
                      rows: 12,
                      disabled: _vm.readonly
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.alsoNotify.label,
                          _vm.job.alsoNotify,
                          function(val) {
                            _vm.job.alsoNotify = val
                          },
                          true,
                          { warningCount: 45, maxChar: 0 }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.alsoNotify,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "alsoNotify", $$v)
                      },
                      expression: "job.alsoNotify"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.containerLoadType.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "containerLoadType" },
                  slot: "containerLoadType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.containerLoadType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.containerLoadType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "containerLoadType",
                        disabled: _vm.readonly
                      },
                      on: {
                        change: function($event) {
                          return _vm.containerLoadType_Change()
                        }
                      },
                      model: {
                        value: _vm.job.containerLoadType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "containerLoadType", $$v)
                        },
                        expression: "job.containerLoadType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: "FCL",
                          label: _vm.$t("CargoMsg.Cargo_FCL")
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "LCL",
                          label: _vm.$t("CargoMsg.Cargo_DirectConsol")
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "BB",
                          label: _vm.$t("CargoMsg.Cargo_CoLoadConsol")
                        }
                      }),
                      _c("el-option", {
                        attrs: { value: "BC", label: "Buyer Console" }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "BULK",
                          label: _vm.$t("CargoMsg.Cargo_BulkCargo")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.job.containerLoadType === "FCL" ||
                    _vm.job.containerLoadType === "BB",
                  expression:
                    "job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
                }
              ],
              attrs: { slot: "seaEq", "label-width": "0" },
              slot: "seaEq"
            },
            [
              _c("booking-sea-eq-data-grid", {
                ref: "bookingSeaEqDataGrid",
                staticStyle: { width: "100%" },
                attrs: {
                  value: _vm.seaEqList,
                  "container-load-type": _vm.job.containerLoadType,
                  "is-edit": _vm.isEdit,
                  job: _vm.job,
                  lob: "RE",
                  "hide-soc": true
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.quantityConsignActual.visible,
                  expression: "elementDict.quantityConsignActual.visible"
                }
              ],
              attrs: { slot: "quantityConsignActual" },
              slot: "quantityConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.quantityConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.quantityConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "quantityContract",
                      precision: 0,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.SEUtils.changeQWCRule(function() {
                          _vm.job.quantityActual = _vm.job.quantityContract
                        }, null)
                      }
                    },
                    model: {
                      value: _vm.job.quantityContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "quantityContract", $$v)
                      },
                      expression: "job.quantityContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "quantityActual",
                      precision: 0,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.SEUtils.changeQWCRule(null, function() {
                          _vm.job.quantityContract = _vm.job.quantityActual
                        })
                      }
                    },
                    model: {
                      value: _vm.job.quantityActual,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "quantityActual", $$v)
                      },
                      expression: "job.quantityActual"
                    }
                  }),
                  _c("span", [_vm._v("PCS")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.weightConsignActual.visible,
                  expression: "elementDict.weightConsignActual.visible"
                }
              ],
              attrs: { slot: "weightConsignActual" },
              slot: "weightConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.weightConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.weightConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "weightContract",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.SEUtils.changeQWCRule(function() {
                          _vm.job.weightActual = _vm.job.weightContract
                        }, null)
                      }
                    },
                    model: {
                      value: _vm.job.weightContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "weightContract", $$v)
                      },
                      expression: "job.weightContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "weightActual",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.SEUtils.changeQWCRule(null, function() {
                          _vm.job.weightContract = _vm.job.weightActual
                        })
                      }
                    },
                    model: {
                      value: _vm.job.weightActual,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "weightActual", $$v)
                      },
                      expression: "job.weightActual"
                    }
                  }),
                  _c("span", [_vm._v("KGS")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.cubageConsignActual.visible,
                  expression: "elementDict.cubageConsignActual.visible"
                }
              ],
              attrs: { slot: "cubageConsignActual" },
              slot: "cubageConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.cubageConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.cubageConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "cubageContract",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.SEUtils.changeQWCRule(function() {
                          _vm.job.cubageActual = _vm.job.cubageContract
                        }, null)
                      }
                    },
                    model: {
                      value: _vm.job.cubageContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cubageContract", $$v)
                      },
                      expression: "job.cubageContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "cubageActual",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        _vm.SEUtils.changeQWCRule(null, function() {
                          _vm.job.cubageContract = _vm.job.cubageActual
                        })
                      }
                    },
                    model: {
                      value: _vm.job.cubageActual,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cubageActual", $$v)
                      },
                      expression: "job.cubageActual"
                    }
                  }),
                  _c("span", [_vm._v("CBM")])
                ],
                1
              )
            ],
            1
          ),
          _vm.elementDict.customerRefNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerRefNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "customerRefNo",
                      trim: true
                    },
                    model: {
                      value: _vm.job.customerRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customerRefNo", $$v)
                      },
                      expression: "job.customerRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.jobNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "jobNo" }, slot: "jobNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.jobNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "job-no-color",
                    attrs: { no: "jobNo", disabled: true },
                    model: {
                      value: _vm.job.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "jobNo", $$v)
                      },
                      expression: "job.jobNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseNo" }, slot: "warehouseNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "warehouseNo", disabled: _vm.readonly },
                    model: {
                      value: _vm.job.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "warehouseNo", $$v)
                      },
                      expression: "job.warehouseNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quotationNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "quotationNo" }, slot: "quotationNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quotationNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "quotationNo",
                      value: _vm.job.quotationNo,
                      disabled: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerId" }, slot: "customerId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerId.label
                    },
                    slot: "label"
                  }),
                  _vm.accountObjectControlMode === 2
                    ? _c("cargo-sales-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customerId",
                          disabled:
                            !(!_vm.job.mbl && _vm.electricBusinessBtnEnable) ||
                            _vm.readonly,
                          "method-params": { customer: true, active: true },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.customerId || "",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { parentCallBack: _vm.txtCustomerId_changeHandler }
                      })
                    : _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customerId",
                          disabled:
                            !(!_vm.job.mbl && _vm.electricBusinessBtnEnable) ||
                            _vm.readonly,
                          "method-params": { customer: true, active: true },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.customerId || "",
                          "static-options": _vm.customerCmpList,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { change: _vm.txtCustomerId_changeHandler }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerContact.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerContact" }, slot: "customerContact" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerContact.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerContact.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "customerContact",
                        disabled:
                          !_vm.electricBusinessBtnEnable || _vm.readonly,
                        filterable: "",
                        "allow-create": true,
                        placeholder: ""
                      },
                      on: { change: _vm.tfLinkman_closeHandler },
                      model: {
                        value: _vm.job.customerContact,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customerContact", $$v)
                        },
                        expression: "job.customerContact"
                      }
                    },
                    _vm._l(_vm.contactList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.contactPerson,
                          value: item.contactPerson
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.sales.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "sales" }, slot: "sales" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.sales.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "sales",
                      disabled:
                        !(
                          !_vm.job.trustFromJob &&
                          _vm.electricBusinessBtnEnable &&
                          (!_vm.validateCustomerSales ||
                            (_vm.isSpecifiedSalesBusiness &&
                              _vm.validateCustomerSales))
                        ) || _vm.readonly,
                      "method-params": {
                        officeId:
                          !_vm.isSpecifiedSalesBusiness && _vm.salesOfficeCheck
                            ? _vm.$store.getters.currentOfficeId
                            : "",
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.job.sales || "",
                      "static-options": _vm.salesList,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: { change: _vm.txtSales_changeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesDepartment" }, slot: "salesDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-new-select", {
                    attrs: {
                      no: "salesOffice",
                      disabled:
                        !(_vm.job.sales > 0 && _vm.job.salesDepartment > 0) ||
                        _vm.readonly,
                      "sales-id": _vm.job.sales,
                      "office-id": _vm.job.salesOffice,
                      "department-id": _vm.job.salesDepartment,
                      "show-office-prefix": false,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.salesDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtSalesOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtSalesOffice" }, slot: "txtSalesOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtSalesOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtSalesOffice.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "txtSalesOffice",
                      disabled: true,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    model: {
                      value: _vm.txtSalesOffice,
                      callback: function($$v) {
                        _vm.txtSalesOffice = $$v
                      },
                      expression: "txtSalesOffice"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSalesId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSalesId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSalesId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "cargoSalesId",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "salesOfGoods"
                      },
                      "default-value": _vm.job.cargoSalesId || "",
                      "static-options": _vm.cargoSalesList,
                      placeholder: " "
                    },
                    on: { change: _vm.cargoSalesChargeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.op.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "op" }, slot: "op" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.op.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.op.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "op",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "op",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.op || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.op
                    },
                    on: { change: _vm.txtOPChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "opDepartment",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "office-id": _vm.job.opOffice,
                      enables: true,
                      "department-id": _vm.job.opDepartment,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.opDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opOffice" }, slot: "opOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "opOffice",
                      disabled: _vm.isEntrustOrder() || _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.opOffice || "",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.opOffice = p.value
                        _vm.opOfficeChargeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dc.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dc" }, slot: "dc" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dc.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.dc.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "dc",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "doc",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.dc || "",
                      "static-options": _vm.userPortRoleData.doc || _vm.dcList,
                      placeholder: " "
                    },
                    on: { change: _vm.dcChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csr.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csr" }, slot: "csr" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csr.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.csr.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "csr",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "csr",
                        officeId: _vm.job.opOffice
                      },
                      "default-value": _vm.job.csr || "",
                      "static-options": _vm.userPortRoleData.csr || _vm.csrList,
                      placeholder: " "
                    },
                    on: { change: _vm.csrChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.planner.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "planner" }, slot: "planner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.planner.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.planner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "planner",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "railwayLine",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.planner || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.railwayLine
                    },
                    on: { change: _vm.txtPlannerChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.overseaOp.visible,
                  expression: "elementDict.overseaOp.visible"
                }
              ],
              attrs: { slot: "overseaOp" },
              slot: "overseaOp"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.overseaOp.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "overseaOp",
                attrs: {
                  no: "overseaOp",
                  disabled: _vm.readonly,
                  "default-value": _vm.job.overseaOp || "",
                  "method-params": { category: "role", shape: "overseaOp" },
                  "static-options": _vm.isHc
                    ? null
                    : _vm.userPortRoleData.overseaOp ||
                      _vm.overseaAgentUsersList,
                  "merge-load": true
                },
                on: {
                  change: function(p) {
                    _vm.job.overseaOp = p.value
                    _vm.OverseaCustomerUtils.overseaOpChangeHandler(_vm.view, p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.siteOP.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "siteOP" }, slot: "siteOP" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.siteOP.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "siteOP",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "siteOp"
                      },
                      "default-value": _vm.job.siteOP || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.siteOp
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "csrDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.csrOffice),
                      enables: true,
                      "department-id": Number(_vm.job.csrDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.csrDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "csrOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.csrOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.csrOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "dcDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.dcOffice),
                      enables: true,
                      "department-id": Number(_vm.job.dcDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.dcDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "dcOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.dcOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.dcOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transportType.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportType" }, slot: "transportType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transportType",
                      disabled: _vm.readonly,
                      "select-type":
                        _vm.TYPE_NAMES.basic_data_TransportationType,
                      filterable: "",
                      "default-value": _vm.job.transportType,
                      "tag-name":
                        this.$store.getters.language === "zh"
                          ? "chineseName"
                          : "englishName",
                      "tag-value": "code",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.transportType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.fullHalf.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "fullHalf" }, slot: "fullHalf" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.fullHalf.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.fullHalf.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "fullHalf",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.local_cache_FullHalf,
                      filterable: "",
                      "default-value": _vm.job.fullHalf,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.fullHalf = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transportLine.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportLine" }, slot: "transportLine" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportLine.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportLine.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transportLine",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_RailwayLine,
                      filterable: "",
                      "default-value": _vm.job.transportLine,
                      placeholder: _vm.$t("SeaExport.RequiredItem"),
                      "tag-name": "name"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.transportLine = p.value
                        _vm.onTransportLineChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.etd.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "etd" }, slot: "etd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.etd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.etd.label },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "etd",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: "",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    model: {
                      value: _vm.job.etd,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "etd", $$v)
                      },
                      expression: "job.etd"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.eta.visible && _vm.job.lob === "RE"
            ? _c(
                "el-form-item",
                { attrs: { slot: "eta" }, slot: "eta" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.eta.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.eta.label },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "eta",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.eta,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "eta", $$v)
                      },
                      expression: "job.eta"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.eta.visible && _vm.job.lob === "RI"
            ? _c(
                "el-form-item",
                { attrs: { slot: "eta" }, slot: "eta" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.eta.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.eta.label },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "eta",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.eta,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "eta", $$v)
                      },
                      expression: "job.eta"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate &&
          _vm.elementDict.customsDate.visible &&
          _vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "div",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("micro-app", {
                    attrs: {
                      name: "child-operation-date-re",
                      url:
                        _vm.$store.getters.frontEndPluginUrl +
                        "/operationDateItem",
                      "router-mode": "pure",
                      destroy: ""
                    },
                    on: { datachange: _vm.operationDateDataChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate &&
          _vm.elementDict.customsDate.visible &&
          _vm.job.lob === "RE" &&
          !_vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "customsDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customsDate", $$v)
                      },
                      expression: "job.customsDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate &&
          _vm.elementDict.customsDate.visible &&
          _vm.job.lob === "RI" &&
          !_vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "customsDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customsDate", $$v)
                      },
                      expression: "job.customsDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transitStation.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transitStation" }, slot: "transitStation" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transitStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transitStation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transitStation",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_RailwayStation,
                      filterable: "",
                      "default-value": _vm.job.transitStation,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.transitStation = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationStation.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationStation" },
                  slot: "destinationStation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationStation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "destinationStation",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_RailwayStation,
                      filterable: "",
                      "default-value": _vm.job.destinationStation,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: { parentCallBack: _vm.destinationStationChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationCountry.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationCountry" },
                  slot: "destinationCountry"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationCountry.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationCountry.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "destinationCountry",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Country,
                      filterable: "",
                      "default-value": _vm.job.destinationCountry
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.destinationCountry = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSource.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSource.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSource.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "cargoSource",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.local_cache_CargoSource,
                      "default-value": _vm.job.cargoSource,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.cargoSource = p.value
                        _vm.cargoSource_Change()
                        _vm.txtCargoSourceChangeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.customJobType.visible,
                  expression: "elementDict.customJobType.visible"
                }
              ],
              attrs: { slot: "customJobType" },
              slot: "customJobType"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.customJobType.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.customJobType.label
                },
                slot: "label"
              }),
              _c("cargo-advance-select", {
                ref: "customJobType",
                attrs: {
                  no: "customJobType",
                  disabled: _vm.readonly,
                  "select-type": _vm.TYPE_NAMES.basic_data_CutomJobType,
                  filterable: "",
                  "static-options": _vm.getCustomJobType,
                  "default-value": _vm.job.customJobType,
                  placeholder: _vm.$t("Message.PleaseSelect")
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.job.customJobType = p.value
                    _vm.onCustomJobTypeChange()
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.portAgent.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "portAgent" }, slot: "portAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.portAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.portAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "portAgent",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        portAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.job.portAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.portAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.forwardingAgent.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "forwardingAgent" }, slot: "forwardingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.forwardingAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.forwardingAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "forwardingAgent",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        forwardingAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.job.forwardingAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.forwardingAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.destinationAgent.visible,
                  expression: "elementDict.destinationAgent.visible"
                }
              ],
              attrs: { slot: "destinationAgent" },
              slot: "destinationAgent"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.destinationAgent.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.destinationAgent.label
                },
                slot: "label"
              }),
              _c("cargo-company-select", {
                ref: "destinationAgent",
                staticStyle: { width: "300px" },
                attrs: {
                  no: "destinationAgent",
                  disabled: _vm.readonly,
                  "method-params": {
                    overseaAgent: true,
                    active: true,
                    companyLob: "railwayExport"
                  },
                  "check-credit": true,
                  job: _vm.job,
                  "default-value": _vm.job.destinationAgent || "",
                  filterable: "",
                  headers: [_vm.$t("Partners.englishName")],
                  fields: ["englishName"],
                  "tag-name": "englishName"
                },
                on: { change: _vm.txtDestinationAgentChangeHandler }
              })
            ],
            1
          ),
          _vm.elementDict.designationAgent.visible &&
          _vm.job.cargoSource === "NC"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "designationAgent" },
                  slot: "designationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.designationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.designationAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      no: "designationAgent",
                      disabled: _vm.readonly,
                      "method-params": { designationAgent: true, active: true },
                      "check-credit": true,
                      job: _vm.job,
                      "default-value": _vm.job.designationAgent || "",
                      "tag-name": "englishName",
                      placeholder: " "
                    },
                    on: { change: _vm.txtDesignationAgentChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentMethod.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentMethod" }, slot: "paymentMethod" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentMethod.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentMethod.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "paymentMethod",
                      disabled: _vm.readonly,
                      "select-type":
                        _vm.selectTypeNames.basic_data_PaymentMethod,
                      "method-params": {
                        companyLob: "railwayExport",
                        paymentMethod: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.job.paymentMethod,
                      "tag-name":
                        this.$store.getters.language === "zh"
                          ? "chineseName"
                          : "englishName",
                      "tag-value": "code",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.paymentMethod = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vessel.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "vessel" }, slot: "vessel" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vessel.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vessel.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "vessel" },
                    model: {
                      value: _vm.job.vessel,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "vessel", $$v)
                      },
                      expression: "job.vessel"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.voyageFlight.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "voyageFlight" }, slot: "voyageFlight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.voyageFlight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.voyageFlight.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "voyageFlight" },
                    model: {
                      value: _vm.job.voyageFlight,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "voyageFlight", $$v)
                      },
                      expression: "job.voyageFlight"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoType.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoType" }, slot: "cargoType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "cargoType",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_CargoType,
                      headers: [_vm.$t("Partners.chineseName")],
                      fields: ["chineseName"],
                      "filter-field-names": ["chineseName"],
                      "method-params": { sea: true },
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.job.cargoType
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.cargoType = p.value
                        _vm.onCargoTypeChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.packing.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "packing" }, slot: "packing" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    staticStyle: { width: "260px" },
                    attrs: {
                      no: "packing",
                      disabled: _vm.readonly,
                      "default-value": _vm.job.packing,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.packing = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoChineseName.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoChineseName" },
                  slot: "cargoChineseName"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoChineseName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoChineseName.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "cargoChineseName",
                      type: "textarea",
                      rows: 3,
                      disabled: !_vm.isEdit
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                          _vm.job.cargoChineseName,
                          function(val) {
                            _vm.job.cargoChineseName = val
                          },
                          true,
                          { autoUppercase: true }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.cargoChineseName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cargoChineseName", $$v)
                      },
                      expression: "job.cargoChineseName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoEnglishName.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoEnglishName" },
                  slot: "cargoEnglishName"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoEnglishName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoEnglishName.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "cargoEnglishName",
                      type: "textarea",
                      rows: 3,
                      disabled: !_vm.isEdit,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                          _vm.job.cargoEnglishName,
                          function(val) {
                            _vm.job.cargoEnglishName = val
                          },
                          _vm.isUppercaseByConfig,
                          { autoUppercase: _vm.isUppercaseByConfig }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.cargoEnglishName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cargoEnglishName", $$v)
                      },
                      expression: "job.cargoEnglishName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.hsCode.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "hsCode" }, slot: "hsCode" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.hsCode.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.hsCode.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "hsCode",
                      type: "textarea",
                      rows: 3
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.HsCode"),
                          _vm.job.hsCode,
                          function(val) {
                            _vm.job.hsCode = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.hsCode,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "hsCode", $$v)
                      },
                      expression: "job.hsCode"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mark.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "mark" }, slot: "mark" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mark.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mark.label },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "mark",
                      type: "textarea",
                      rows: 3,
                      disabled: !_vm.isEdit,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Marks"),
                          _vm.job.mark,
                          function(val) {
                            _vm.job.mark = val
                          },
                          _vm.isUppercaseByConfig,
                          { autoUppercase: _vm.isUppercaseByConfig }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.mark,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "mark", $$v)
                      },
                      expression: "job.mark"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsBroker.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsBroker.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsBroker.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsBroker",
                      disabled: !_vm.job.customs || _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "data-filter-function": _vm.customsBrokerFilter,
                      filterable: "",
                      "default-value": _vm.job.customsBroker || "",
                      placeholder: _vm.$t(
                        "SeaExport.PleaseTickCustomsDeclarationOption"
                      ),
                      "method-params": {
                        customsBroker: true,
                        companyLob: "seaExport",
                        active: true
                      }
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.customsBrokerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDeclarationType.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "customsDeclarationType" },
                  slot: "customsDeclarationType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDeclarationType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDeclarationType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsDeclarationType",
                      disabled: !_vm.job.customs || _vm.readonly,
                      "select-type":
                        _vm.TYPE_NAMES.basic_data_CustomsDeclarationType,
                      filterable: "",
                      "default-value":
                        _vm.job.customsDeclarationType === -1
                          ? ""
                          : _vm.job.customsDeclarationType,
                      placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.customsDeclarationType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carryingCmp.visible && !_vm.isSalesForSzfs
            ? _c(
                "el-form-item",
                { attrs: { slot: "carryingCmp" }, slot: "carryingCmp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carryingCmp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carryingCmp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "landTransportation",
                      disabled: !_vm.job.landTransportation || _vm.readonly,
                      "method-params": { truckCmp: true, active: true },
                      "default-value": _vm.job.carryingCmp || "",
                      placeholder: _vm.$t(
                        "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                      )
                    },
                    on: { change: _vm.carryingCmpChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.satisfiedRequests.visible,
                  expression: "elementDict.satisfiedRequests.visible"
                }
              ],
              attrs: { slot: "satisfiedRequests" },
              slot: "satisfiedRequests"
            },
            [
              _c("special-requests-grid", {
                ref: "selectedSpecialRequest",
                attrs: {
                  no: "satisfiedRequests",
                  "is-edit": _vm.isEdit,
                  "customer-id": _vm.job.customerId,
                  lob: _vm.job.lob,
                  job: _vm.job
                },
                model: {
                  value: _vm.job.satisfiedRequests,
                  callback: function($$v) {
                    _vm.$set(_vm.job, "satisfiedRequests", $$v)
                  },
                  expression: "job.satisfiedRequests"
                }
              })
            ],
            1
          ),
          _vm.elementDict.remarks.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "remarks" }, slot: "remarks" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.remarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "remarks",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Remarks"),
                          _vm.job.remarks,
                          function(val) {
                            _vm.job.remarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "remarks", $$v)
                      },
                      expression: "job.remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.rateType && _vm.elementDict.rateType.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "rateType" }, slot: "rateType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.rateType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "rateType",
                        clearable: "",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.job.rateType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "rateType", $$v)
                        },
                        expression: "job.rateType"
                      }
                    },
                    _vm._l(_vm.rateType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.job,
          "own-permission": _vm.hasChooseOwnTransceiverPermission,
          "customer-cmp-list": _vm.customerCmpList,
          "use-empty-customer-cmp-list": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }